'use strict';

angular.module('chatEngine.engines.base', [])

.controller('BaseEngineCtrl', ['$scope', 'Engine', '$routeParams', 'Dialog',
    function($scope, Engine, $routeParams, Dialog) {
    $scope.loadedEngine = false;
    $scope.engineData = null;
    $scope.engineMeta = null;

    $scope.init = function(type, successFn) {
        $scope.engineData = Engine.getDataByType(type);
        successFn = successFn || function() {};

        if($scope.engineData === null) {
            Engine.query(function(engines) {
                Engine.setData(engines); // need this here, do not rely on the watcher
                $scope.engineData = Engine.getDataById($routeParams.id);
                if($scope.engineData !== null) {
                    $scope.engineMeta = Engine.getMetaById($scope.engineData.id);
                    successFn($scope.engineData);
                    $scope.loadedEngine = true;
                } else {
                    initError();
                }
            }, initError);
        } else {
            $scope.engineMeta = Engine.getMetaById($scope.engineData.id);
            successFn($scope.engineData);
            $scope.loadedEngine = true;
        }

        function initError() {
            $scope.loadedEngine = false;
            Dialog.alert('Error', 'Something went wrong while fetching your engine, please try again later.');
        }
    };

    $scope.$watch('engineData', function() {
        Engine.setDataWithEngine($scope.engineData);
    }, true);
}]);
